import { defineStore } from 'pinia';
import {ref} from 'vue';

export const useCalendarStore = defineStore('calendar', () => {
    const shownStart = ref({});
    const shownEnd = ref({});

    function changeShownStart(month, year) {
        shownStart.value = {
            month: month,
            year: year
        };
    }

    function changeShownEnd(month, year) {
        shownEnd.value = {
            month: month,
            year: year
        };
    }

    return {
        shownStart,
        shownEnd,
        changeShownStart,
        changeShownEnd
    }
})